import React from 'react';
import {
    Box,
    Container,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    useTheme,
    styled,
} from '@mui/material';

const menuData = [
    {
        category: 'Standard Items (by pounds)',
        note: '$20 Minimum Order',
        items: [
            { name: 'Next Day Service', price: '$1.60 per pound' },
            { name: 'Same Day Service', price: '$1.90 per pound' },
            { name: 'Dry & Fold', price: '$1.15 per pound' },
        ],
    },
    {
        category: 'Comforters',
        items: [
            { name: 'Comforter (King)', price: '$18.00' },
            { name: 'Comforter (Queen)', price: '$16.00' },
            { name: 'Comforter (Full/Twin)', price: '$14.00' },
            { name: 'Down Comforter (King)', price: '$25.00' },
            { name: 'Down Comforter (Queen)', price: '$20.00' },
            { name: 'Down Comforter (Full/Twin)', price: '$15.00' },
        ],
    },
    {
        category: 'Mattress Pads',
        items: [
            { name: 'Mattress Pad (King)', price: '$17.00' },
            { name: 'Mattress Pad (Queen)', price: '$15.00' },
            { name: 'Mattress Pad (Full/Twin)', price: '$13.00' },
            { name: 'Tablecloths', price: '$6.00' },
        ],
    },
    {
        category: 'Pillows',
        items: [
            { name: 'Pillow (Small)', price: '$8.00' },
            { name: 'Pillow (Feather)', price: '$15.00' },
        ],
    },
    {
        category: 'Blankets & Horse Blankets',
        items: [
            { name: 'Blanket (King)', price: '$19.00' },
            { name: 'Blanket (Queen)', price: '$17.00' },
            { name: 'Blanket (Full/Twin)', price: '$15.00' },
            { name: 'Horse Blanket (Large)', price: '$18.00' },
            { name: 'Horse Blanket (Medium)', price: '$16.00' },
            { name: 'Horse Blanket (Small)', price: '$14.00' },
        ],
    },
    {
        category: 'Rugs',
        items: [
            { name: 'Rug (Lg/Md)', price: '$10.00' },
            { name: 'Rug (Small)', price: '$8.00' },
            { name: 'Rug Runner', price: '$15.00' },
            { name: 'Sleeping Bag', price: '$18.00' },
        ],
    },
    {
        category: 'Pet Beds',
        items: [
            { name: 'Pet Bed (Large)', price: '$18.00' },
            { name: 'Pet Bed (Medium)', price: '$15.00' },
            { name: 'Pet Bed (Small)', price: '$13.00' },
        ],
    },
];

const HeaderSection = styled(Box)(({ theme }) => ({
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.background.paper})`,
    padding: "40px 20px",
    textAlign: "center",
    borderBottomLeftRadius: "30px",
    borderBottomRightRadius: "30px",
    color: theme.palette.text.primary,
}));

const Menu: React.FC = () => {
    const theme = useTheme(); // Get theme colors

    return (
        <Box sx={{ backgroundColor: theme.palette.background.default }}>
            <HeaderSection>
                <Typography variant="h4" fontWeight="bold">
                    Drop Off Wash & Fold Prices
                </Typography>
            </HeaderSection>
            <Container sx= {{ marginTop: 5}}>
                {menuData.map((group, groupIndex) => (
                    <Box key={groupIndex} sx={{ mb: 6 }}>
                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                            {group.category}
                        </Typography>
                        <TableContainer component={Paper}>
                            <Table >
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: theme => theme.palette.primary.main }}>
                                        <TableCell
                                            sx={{
                                                color: theme => theme.palette.common.white,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            Service
                                        </TableCell>
                                        <TableCell
                                            align="right"
                                            sx={{
                                                color: theme => theme.palette.common.white,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            Price
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ backgroundColor: theme => theme.palette.background.paper }}>
                                    {group.items.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{item.name}</TableCell>
                                            <TableCell align="right">{item.price}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {group.note && (
                            <Typography
                                variant="caption"
                                display="block"
                                align="right"
                                sx={{ mt: 1, fontStyle: 'italic' }}
                            >
                                {group.note}
                            </Typography>
                        )}
                    </Box>
                ))}
            </Container>
        </Box>
    );
};

export default Menu;
